import moment from 'moment';
import { useCallback } from 'react';
import { Col, Nav, Row, Tab } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router';
import MusicReportingBatch from './MusicReportingBatch';
import MusicReportingCreateBatch from './MusicReportingCreateBatch';

const allMonthsForPast5years: { id: string; name: string; monthId: number; yearId: number }[] = [];

for (let i = 0; i < 60; i++) {
  const newDate = moment().add(-i, 'month');
  const data = {
    id: `${newDate.month() + 1}-${newDate.year()}`,
    name: newDate.format('MMMM YYYY'),
    monthId: newDate.month() + 1,
    yearId: newDate.year(),
  };
  allMonthsForPast5years.push(data);
}

const MusicReporting = () => {
  // fetch data
  const history = useHistory();
  // parse id params from url
  const { id: currentBatchId } = useParams<{ id: string }>();
  const setActiveList = useCallback(
    (listId) => {
      const pathName = window.location.pathname;
      let originPath = pathName;
      if (!pathName.endsWith('music-reporting')) {
        const elmts = pathName.split('/');
        elmts.pop();
        originPath = elmts.join('/');
      }
      history.push(`${originPath}/${listId}`);
    },
    [history]
  );

  const list = allMonthsForPast5years;

  console.log('currentBatchid', currentBatchId);

  return (
    // @ts-ignore
    <Tab.Container className="h-100" activeKey={currentBatchId} onSelect={setActiveList}>
      <Row className="mb-5 h-100 cp-list">
        <Col>
          <MusicReportingCreateBatch />
          <Nav variant="pills">
            {list.map((b) => (
              <Nav.Item key={b.id} className="w-100 text-center position-relative">
                <Nav.Link eventKey={b.id} className="justify-content-center">
                  {b.name}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </Col>
        <Col className="col-9">
          <Tab.Content className="h-100">
            {currentBatchId && (
              <MusicReportingBatch
                monthId={parseInt(currentBatchId.split('-')[0], 10)}
                yearId={parseInt(currentBatchId.split('-')[1], 10)}
              />
            )}
          </Tab.Content>
        </Col>
      </Row>
    </Tab.Container>
  );
};

export default MusicReporting;
